import api from "./api";

function toParams({ page, pageSize, search, sortBy, sortOrder, ...rest } = {}) {
    const params = { ...rest };
    if (page) params.page = page;
    if (pageSize) params.page_size = pageSize;
    if (search) params.search = search;
    if (sortBy) params.sort_by = sortBy;
    if (sortOrder) params.sort_order = sortOrder;
    return params;
}

export const assetsService = {
    async list(query = {}) {
        const { data } = await api.get("/assets", { params: toParams(query) });
        return data;
    },
    async get(id) {
        const { data } = await api.get(`/assets/${id}`);
        return data;
    },
    async getStats(id) {
        const { data } = await api.get(`/assets/${id}/stats`);
        return data;
    },
    async getWorkOrders(id, limit = 50) {
        const { data } = await api.get(`/assets/${id}/work-orders`, { params: { limit } });
        return data;
    },
    async create(payload) {
        const { data } = await api.post("/assets", payload);
        return data;
    },
    async update(id, payload) {
        const { data } = await api.patch(`/assets/${id}`, payload);
        return data;
    },
    async remove(id) {
        await api.delete(`/assets/${id}`);
    },
    async setOperationalStatus(id, status) {
        const { data } = await api.patch(`/assets/${id}/operational-status`, { status });
        return data;
    },
    async categories() {
        const { data } = await api.get("/assets/categories");
        return data;
    },
    async photoCategories() {
        const { data } = await api.get("/assets/photo-categories");
        return data;
    },
    async getPublic(id) {
        const { data } = await api.get(`/public/assets/${id}`);
        return data;
    },
    async getTimeline(id) {
        const { data } = await api.get(`/assets/${id}/timeline`);
        return data;
    },
};
